/**
 * Valor total de um negócio, na mesma ordem de prioridade em toda a UI
 * (KanbanCard, DealHeader/WinDealModal):
 *   1. deal_value do funnel mapping (definido inline no Kanban / catálogo)
 *   2. amount do Deal vinculado (se do mesmo funil)
 *   3. soma dos produtos da conversa (filtrados pelo funil)
 *
 * @param {Object} conversation - conversa (payload da API, com deal/conversation_products quando carregados)
 * @param {Object} options
 * @param {Object} [options.mapping] - funnel mapping explícito; sem ele usa conversation.deal_value
 * @param {number|string} [options.funnelId] - funil corrente para filtrar deal/produtos
 * @returns {number}
 */
export function getDealTotalValue(
  conversation = {},
  { mapping, funnelId } = {}
) {
  const rawMappingValue = mapping
    ? mapping.deal_value
    : conversation.deal_value;
  if (
    rawMappingValue !== null &&
    rawMappingValue !== undefined &&
    rawMappingValue !== ''
  ) {
    return parseFloat(rawMappingValue) || 0;
  }

  const deal = conversation.deal;
  if (
    deal?.amount &&
    (!funnelId || String(deal.funnel_id) === String(funnelId))
  ) {
    return parseFloat(deal.amount) || 0;
  }

  const products = conversation.conversation_products || [];
  const filtered = funnelId
    ? products.filter(
        product =>
          !product.funnel_id || String(product.funnel_id) === String(funnelId)
      )
    : products;

  return filtered.reduce(
    (sum, product) => sum + (parseFloat(product.amount) || 0),
    0
  );
}
